import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { withStyles, Tooltip, Button, Fab } from '@material-ui/core';
import Check from '@material-ui/icons/Check';
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import {
  cardTitle,
  roseColor
} from "assets/jss/material-dashboard-pro-react.jsx";

import { UploadFileContentImportHelper } from '../../helpers/UploadFileContentImportHelper.js';

import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";

import Api from '../../api/Api.js';
import ReportEndpoints from '../../api/ReportEndpoints';
import Loading from '../../components/Loading/Loading';
import { store } from '../../redux/store';
import { SET_PAGE_TITLE } from '../../redux/types';

const styles = theme => ({
  cardTitle,
  cardTitleWhite: {
      ...cardTitle,
      color: "#FFFFFF",
      marginTop: "0"
  },
  cardCategoryWhite: {
      margin: "0",
      color: "rgba(255, 255, 255, 0.8)",
      fontSize: ".875rem"
  },
  cardCategory: {
      color: "#999999",
      marginTop: "10px"
  },
  icon: {
      color: "#333333",
      margin: "10px auto 0",
      width: "130px",
      height: "130px",
      border: "1px solid #E5E5E5",
      borderRadius: "50%",
      lineHeight: "174px",
      "& svg": {
          width: "55px",
          height: "55px"
      },
      "& .fab,& .fas,& .far,& .fal,& .material-icons": {
          width: "55px",
          fontSize: "55px"
      }
  },
  iconRose: {
      color: roseColor
  },
  marginTop30: {
      marginTop: "30px"
  },
  testimonialIcon: {
      marginTop: "30px",
      "& svg": {
          width: "40px",
          height: "40px"
      }
  },
  cardTestimonialDescription: {
      fontStyle: "italic",
      color: "#999999"
  },
  button: {
    margin: "15px",
  },
  rightIcon: {
    marginLeft: "5px",
  }
});

class FtpAdd extends Component {
   constructor(props) {
      super(props);
      this.uploadSSH = React.createRef();
   }

   UNSAFE_componentWillMount() {
    store.dispatch({ type: SET_PAGE_TITLE, payload: `ADD FTP SERVER` });
   }

  state = { 
    server: {},    
    waiting: false,
    saving: false,
  };

  change(event, name, type = "required") {
    switch (type) {        
        case "required":
            if (event.target.value) {
                this.setState({ [name + "State"]: "success" });
            } else {
                this.setState({ [name + "State"]: "error" });
            }
            break;        
       default:
            break;
    }
    if (!event) return;
    this.setState({ server: { ...this.state.server, [name]: event.target.value }});   
  }

  validate(name, value, type = "required") {
    //console.log(value);
    switch (type) {        
        case "required":
            if (value) {
                this.setState({ [name + "State"]: "success" });
            } else {
                this.setState({ [name + "State"]: "error" });
            }
            break;        
       default:
            break;
    }    
  }

  isValidated() {
    ['name', 'host', 'protocol', 'port', 'username', 'password' ].map((name) => {
        this.validate(name, this.state.server[name]);
    })    

    if (
        this.state.nameState === "success" &&
        this.state.hostState === "success" &&
        this.state.protocolState === "success" &&
        this.state.portState === "success" &&
        this.state.usernameState === "success" &&
        this.state.passwordState === "success"
    ) {
        return true;
    }
    //console.log(this.state);
    return false;
  }

  renderSaveButton = () => {          
      if (!this.state.saving) {
        const { classes } = this.props;
        return (
            <Fab 
                style={{ float: 'right' }} 
                variant="extended" 
                className={classes.button} 
                color="primary" 
                onClick={() => { 
                    if(!this.isValidated()) {
                        return;
                    }
                    this.setState({ saving: true });
                    Api.post(ReportEndpoints.ftpAdd, { ...this.state.server })
                        .then(() => {
                            this.props.close();
                            this.props.refresh({ ...this.state, country: this.state.country.value });
                            this.setState({ saving: false })
                        })
                    .catch((e) => this.setState({ loading: false }, () => console.error(e)))
                    this.setState({ saving: false });
                }} 
            >
                Save<Check style={{ marginLeft: 10 }} /> 
            </Fab>
        );
      }

      return(
        <div style={{ float: 'right' }} ><Loading /></div>
      );
  }

  render() {
    if (this.state.waiting) 
      return <Loading />

    const { classes } = this.props;

    return (
    <React.Fragment>
      <GridContainer>
      <GridItem xs={12} sm={12} md={6}>
        <Card style={{ paddingBottom: 4 }}>
            <CardHeader color="success" text>
                <CardText color="success">
                    <h4 className={classes.cardTitleWhite}>Server Details</h4>
                </CardText>
            </CardHeader>
            <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={10} lg={10}>
              <CustomInput
              success={this.state.nameState === "success"}
              error={this.state.nameState === "error"}
              labelText={
                  <span>
                      Server Name <small>(required)</small>
                  </span>
              }
              id="name"
              formControlProps={{
                  fullWidth: true
              }}
              inputProps={{
                  onChange: event => this.change(event, "name", "required"),           
                  value: this.state.server.name,
              }}
              />
              </GridItem>
              <GridItem xs={12} sm={12} md={10} lg={10}>
              <CustomInput
              success={this.state.hostState === "success"}
              error={this.state.hostState === "error"}
              labelText={
                  <span>
                      Host Address <small>(required)</small>
                  </span>
              }
              id="host"
              formControlProps={{
                  fullWidth: true
              }}
              inputProps={{
                  onChange: event => this.change(event, "host"),             
                  value: this.state.server.host,
              }}
              />
              </GridItem>
              <GridItem xs={12} sm={12} md={10} lg={10}>
              <FormControl
                  success={this.state.protocolState === "success"}
                  error={this.state.protocolState === "error"}
                  fullWidth
                  className={classes.selectFormControl}
              >
                  <InputLabel
                      htmlFor="protocol"
                      className={classes.selectLabel}
                      shrink
                  >
                      Protocol
                  </InputLabel>
                  <Select
                      MenuProps={{
                          className: classes.selectMenu
                      }}
                      classes={{
                          select: classes.select
                      }}
                      value={this.state.server.protocol}
                      onChange={(event) => this.change(event, "protocol")}
                      inputProps={{
                          name: "protocol",
                          id: "protocol"
                      }}
                      color="rose"
                  >
                      <MenuItem disabled classes={{ root: classes.selectMenuItem }}>Choose Protocol</MenuItem>
                      <MenuItem
                          classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected
                          }}
                          value="ftp">
                          FTP
                      </MenuItem>
                      <MenuItem
                          classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected
                          }}
                          value="sftp">
                          SFTP
                      </MenuItem>                      
                  </Select>
              </FormControl>
              </GridItem>
              <GridItem xs={12} sm={12} md={10} lg={10}>
                <CustomInput
                success={this.state.portState === "success"}
                error={this.state.portState === "error"}
                labelText={
                    <span>
                        Server Port
                    </span>
                }
                id="port"
                formControlProps={{
                    fullWidth: true
                }}
                inputProps={{
                    onChange: event => this.change(event, "port"),           
                    value: this.state.server.port,
                }}
                />
              </GridItem>
            </GridContainer>
            </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <Card>
            <CardHeader color="success" text>
                <CardText color="success">
                    <h4 className={classes.cardTitleWhite}>Server Credentials</h4>
                </CardText>
            </CardHeader>
            <CardBody>
                <GridItem xs={12} sm={12} md={10} lg={10}>
                <CustomInput
                success={this.state.usernameState === "success"}
                error={this.state.usernameState === "error"}
                labelText={
                    <span>
                        Username
                    </span>
                }
                id="username"
                formControlProps={{
                    fullWidth: true
                }}
                inputProps={{
                    autoComplete:"off",
                    onChange: event => this.change(event, "username"),                
                    value: this.state.server.username,
                }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={10} lg={10}>
                <CustomInput
                success={this.state.passwordState === "success"}
                error={this.state.passwordState === "error"}
                labelText={
                    <span>
                        Password
                    </span>
                }
                id="password"
                formControlProps={{
                    fullWidth: true
                }}
                inputProps={{
                    autoComplete:"new-password",
                    onChange: event => this.change(event, "password"),     
                    type:'password',            
                    value: this.state.server.password,
                }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={10} lg={10}>
                <CustomInput
                success={this.state.sshKeyState === "success"}
                error={this.state.sshKeyState === "error"}
                labelText={
                    <span>
                        SSH Key <small>(Optional)</small>
                    </span>
                }
                id="ssh_key"               
                formControlProps={{
                    fullWidth: true
                }}
                inputProps={{
                    onChange: event => this.change(event, "ssh_key"),   
                    multiline:true,
                    rows:3,             
                    value: this.state.server.ssh_key === "false" ? "" : this.state.server.ssh_key,
                }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={10} lg={10}>              
               <div style={{ minHeight: 40 }}>
               <UploadFileContentImportHelper 
               ref={this.uploadSSH}
               onFileReadComplete={(content) => {
                this.setState({
                    server: {
                        ...this.state.server,
                        ssh_key: content
                    }
                })
               }}
               />
               <Button 
                variant="contained" 
                color="default" 
                className={classes.button}
                onClick={() => {
                    console.log(this.uploadSSH);
                    this.uploadSSH.current.click();                
                }}>
                    Upload SSH Key
                <CloudUploadIcon style={{ marginLeft: 10 }} />
                </Button>       
                </div>
                </GridItem>
            </CardBody>
        </Card>
      </GridItem>      
      </GridContainer>
      <div style={{ minHeight: 40 }}>
        {this.renderSaveButton()}
      </div>
      </React.Fragment>
    );
  }
}
  
export default withStyles({ ...extendedFormsStyle, ...styles })(FtpAdd);